var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_vm._v(" 接口健康状况 "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"prop":"name","label":"接口名","width":"180"}}),_c('el-table-column',{attrs:{"prop":"version","label":"版本号","width":"180"}}),_c('el-table-column',{attrs:{"prop":"status","label":"状态"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }